module.exports = __webpack_public_path__ + "mainassets/img/bg1.4510b401.jpg";